import './storeDetails.css'

import { CloseButton } from 'components'
import { selectStore } from 'data/selectors'
import { LoadingOverlay } from 'LoadingOverlay'
import React, { useCallback, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { emptyObject } from 'utils'

import SisterStores from './SisterStores'
import StoreDetailsInfoContainer from './StoreDetailsInfoContainer'

interface Props {
  countryId: string | null
  fetchStoreDetails?: (storeId: number) => void
  hideModal: () => void
  storeId?: number | null
}

function StoreDetails({ fetchStoreDetails, storeId, hideModal }: Props) {
  const { data, isLoading } = useSelector(selectStore({ storeId: storeId || -1 }))
  const title = `${data?.details?.storeName || ''} ${storeId}`
  const getDetails = useCallback(() => {
    if (!data?.details) return emptyObject

    return {
      ...data.details,
      traffic: data.storeReplenishment,
      results: data.results,
      storeReplenishment: data.storeReplenishment,
    }
  }, [data])
  const details = getDetails()

  useEffect(() => {
    if (storeId) fetchStoreDetails?.(storeId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="modal_content">
      <div className="modal_content-header header-wrapper">
        <span className="modal_content-title">{title}</span>
        <CloseButton onClick={hideModal} />
      </div>

      <LoadingOverlay isLoading={isLoading}>
        <>
          <StoreDetailsInfoContainer
            countryId={data?.details?.countryId}
            details={details}
            exposTimestamp={data?.details?.exposTimestamp}
            resaTimestamp={data?.details?.resaTimestamp}
            trafficTimestamp={data?.details?.trafficTimestamp}
          />
          <SisterStores stores={details.sisterStores} />
        </>
      </LoadingOverlay>
    </div>
  )
}

export default StoreDetails
